import { Button, Modal } from "flowbite-react";
import {
  getNeighborBoothKeys,
  parseBoothNumeric,
  sortBoothNames,
} from "../../Models/BoothRegion";

type BoothDetailModalProps = {
  show: boolean;
  boothName: string | null;
  allBoothNames: string[];
  getAssignee: (boothName: string) => string;
  onClose: () => void;
};

export default function BoothDetailModal({
  show,
  boothName,
  allBoothNames,
  getAssignee,
  onClose,
}: BoothDetailModalProps) {
  if (!boothName) return null;

  const boothKey = boothName.trim().toLowerCase();
  const assignee = getAssignee(boothName);
  const isReserved = assignee !== "Unassigned";
  const neighborKeys = getNeighborBoothKeys(boothName, allBoothNames);
  const neighborNames = sortBoothNames(
    allBoothNames.filter((n) => neighborKeys.has(n.trim().toLowerCase()))
  );
  const showNeighbors =
    parseBoothNumeric(boothName) !== null && neighborNames.length > 1;

  return (
    <Modal show={show} size="md" onClose={onClose} popup dismissible>
      <Modal.Header className="border-b border-gray-200">
        <span className="text-xl font-bold text-gray-900">Booth {boothName}</span>
      </Modal.Header>
      <Modal.Body className="pt-6">
        <div className="rounded-lg border-2 border-blue-700 bg-blue-50 px-5 py-4">
          <p className="text-sm font-bold uppercase tracking-wide text-blue-900 mb-1">
            Assignment
          </p>
          <p
            className={`text-2xl font-bold leading-tight ${
              isReserved ? "text-gray-900" : "text-gray-500 italic"
            }`}
          >
            {assignee}
          </p>
          {!isReserved && (
            <p className="text-sm text-blue-800 mt-2">This booth is available.</p>
          )}
        </div>

        {showNeighbors && (
          <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
            <p className="text-sm font-bold text-gray-900 mb-2">Nearby booths</p>
            <ul className="space-y-1.5 text-sm">
              {neighborNames.map((name) => {
                const isFocused = name.trim().toLowerCase() === boothKey;
                const label = getAssignee(name);
                return (
                  <li
                    key={name}
                    className={
                      isFocused
                        ? "font-bold text-blue-950"
                        : "text-gray-800"
                    }
                  >
                    Booth {name}:{" "}
                    <span
                      className={
                        label === "Unassigned"
                          ? "text-gray-500 italic font-normal"
                          : "font-medium"
                      }
                    >
                      {label}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-t border-gray-200">
        <Button color="gray" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
